/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdjuntoArticuloModelDto } from '../../models/adjunto-articulo-model-dto';

export interface ArticulosControllerObtenerAdjuntoArticulo$Params {

/**
 * Uuid del artículo para obtener el adjunto
 */
  uuidArticulo: string;
}

export function articulosControllerObtenerAdjuntoArticulo(http: HttpClient, rootUrl: string, params: ArticulosControllerObtenerAdjuntoArticulo$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjuntoArticuloModelDto>> {
  const rb = new RequestBuilder(rootUrl, articulosControllerObtenerAdjuntoArticulo.PATH, 'get');
  if (params) {
    rb.path('uuidArticulo', params.uuidArticulo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdjuntoArticuloModelDto>;
    })
  );
}

articulosControllerObtenerAdjuntoArticulo.PATH = '/api/articulos/obtener-adjunto-articulo/{uuidArticulo}';
